export function getAppVersion(): string {
  return __APP_VERSION__
}
